(function () {
  const DESIGNER_SELECTOR = ".setubridgeProductDesigner";
  const BUTTON_SELECTOR = ".btnCustomization";
  const CHECKBOX_ID = "designer-acceptance";
  const ATTRIBUTE_NAME = "attributes['Accepted terms/conditions?']";
  const SHAKE_CLASS = "cart-acceptance--shake";

  function ensureShakeStyles() {
    if (document.getElementById("cart-acceptance-shake-styles")) return;

    const style = document.createElement("style");
    style.id = "cart-acceptance-shake-styles";
    style.textContent = `
      @keyframes cartAcceptanceShake {
        0%, 100% { transform: translateX(0); }
        15% { transform: translateX(-6px); }
        30% { transform: translateX(6px); }
        45% { transform: translateX(-5px); }
        60% { transform: translateX(5px); }
        75% { transform: translateX(-3px); }
        90% { transform: translateX(3px); }
      }
      .${SHAKE_CLASS} {
        animation: cartAcceptanceShake 420ms ease;
      }
    `;
    document.head.appendChild(style);
  }

  function jiggle(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove(SHAKE_CLASS);
    // Force reflow so animation can replay
    void wrapper.offsetWidth;
    wrapper.classList.add(SHAKE_CLASS);
    setTimeout(() => wrapper.classList.remove(SHAKE_CLASS), 450);
  }

  function initAcceptanceControl() {
    const designer = document.querySelector(DESIGNER_SELECTOR);
    if (!designer) return;

    // Prevent duplicate insertion
    if (designer.querySelector(`#${CHECKBOX_ID}`)) return;

    const button = designer.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    ensureShakeStyles();

    // Create wrapper div (optional, for spacing if needed)
    const wrapper = document.createElement("div");
    wrapper.className = "cart__acceptance cart__buttons-wrapper";
    wrapper.style.marginBottom = "12px";

    // Hidden attribute input
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = ATTRIBUTE_NAME;
    hiddenInput.value = "Yes";

    // Checkbox input
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.className = "cart__acceptance__input";
    checkbox.name = "acceptance";
    checkbox.id = CHECKBOX_ID;
    checkbox.setAttribute("data-cart-acceptance-checkbox", "");

    // Label
    const label = document.createElement("label");
    label.setAttribute("for", CHECKBOX_ID);
    label.className = "cart__acceptance__label";
    label.setAttribute("data-cart-acceptance-label", "");
    label.innerHTML =
      "I have selected the <strong>correct size I require</strong> above and accept the <a style=\"text-decoration: underline;\" href=\"/pages/customiser-terms-conditions\" target=\"_blank\">Customiser Terms & Conditions</a>";

    wrapper.appendChild(hiddenInput);
    wrapper.appendChild(checkbox);
    wrapper.appendChild(label);

    // Insert before the customization button
    button.parentNode.insertBefore(wrapper, button);

    // If user clicks the customiser button without accepting terms, jiggle + block click
    // Use capture phase so we can stop other handlers (apps) from firing.
    button.addEventListener(
      "click",
      function (e) {
        const accepted = checkbox.checked;

        if (!accepted) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          jiggle(wrapper);
          checkbox.focus({ preventScroll: false });
        }
      },
      true
    );
  }

  const observer = new MutationObserver(() => {
    initAcceptanceControl();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("DOMContentLoaded", initAcceptanceControl);
})();